import { render } from "./remote-assist.vue?vue&type=template&id=dff1c8be&scoped=true&ts=true"
import script from "./remote-assist.vue?vue&type=script&lang=ts"
export * from "./remote-assist.vue?vue&type=script&lang=ts"

import "./remote-assist.vue?vue&type=style&index=0&id=dff1c8be&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dff1c8be"]])

export default __exports__